import { OnboardingStatusType } from 'api/types/entity';

const SUFFICIENT_STATUSES = new Set([
  OnboardingStatusType.SigningQuestionnaire,
  OnboardingStatusType.SigningDocuments,
  OnboardingStatusType.AwaitingAccountOpening,
  OnboardingStatusType.AccountOpening,
  OnboardingStatusType.AccountOpened,
  OnboardingStatusType.AccountOpeningDenied,
]);

export const isDownloadQuestionnaireStatusSufficient = (
  currentOnboardingStatus: OnboardingStatusType
): boolean => SUFFICIENT_STATUSES.has(currentOnboardingStatus);
